import React from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import Breadcrumb from '../../Common/Breadcrumb';
import { Button } from '../../ui/button';
import ClientsListTable from './OrganisationsListTable';
const items = [{ label: 'Organisations', link: '/admin/organisations' }];

const OrgsList = ({ toggleModal, cyfAdmin }) => {
  return (
    <React.Fragment>
      <div className='flex justify-between items-start'>
        <Breadcrumb items={items} />
        {cyfAdmin && (
          <Button variant='destructive' className='rounded-lg' onClick={() => toggleModal(true, 'recalcAllUsage', null)}>
            Recalculate all Organisations
          </Button>
        )}
      </div>
      <ClientsListTable />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    cyfAdmin: state.profile.details.cyfAdmin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getRecalcUsageStepFunctionStatus: (importArn) => dispatch(ADMINACTIONS.getRecalcUsageStepFunctionStatus(importArn)),
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrgsList);
